<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('dailySchedulesCatalog.breadcrumb' | translate), detailTitle]"></app-breadcrumb>
    </div>

    <div class="daily-schedule-workspace"
         [class.daily-schedule-workspace--loading]="isLoading">
      <mat-card class="daily-schedule-panel daily-schedule-panel--detail"
                [class.daily-schedule-panel--view]="isViewMode"
                [class.daily-schedule-panel--editor]="isCreateMode || isEditMode">
        <div class="daily-schedule-panel__header">
          <div class="daily-schedule-panel__heading">
            @if (isCreateMode || isEditMode) {
            <div class="daily-schedule-panel__heading-icon">
              <mat-icon>calendar_month</mat-icon>
            </div>
            }
            <div class="daily-schedule-panel__heading-copy">
              <span class="daily-schedule-panel__eyebrow">{{ 'dailySchedulesCatalog.breadcrumb' | translate }}</span>
              <div class="daily-schedule-panel__title-row">
                <h3>{{ detailTitle }}</h3>
                @if (selectedSchedule && isViewMode) {
                <span class="daily-schedule-view-status" [class.daily-schedule-view-status--inactive]="!selectedSchedule.isActive"><i></i>{{ selectedSchedule.isActive ? ('common.status.active' | translate) : ('common.status.inactive' | translate) }}</span>
                }
              </div>
              <p>{{ detailDescription }}</p>
            </div>
          </div>
          <div class="daily-schedule-panel__actions">
            @if (selectedSchedule && isViewMode) {
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-primary"
                    *appCanAccess="updateAccess"
                    (click)="startEdit()">
              <mat-icon>edit</mat-icon>
              {{ 'common.update' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-danger"
                    *appCanAccess="deleteAccess"
                    (click)="deleteSelected()">
              <mat-icon>delete_outline</mat-icon>
              {{ 'common.delete' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="goBackToList()">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.back' | translate }}
            </button>
            }
            @if (isCreateMode || isEditMode) {
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="cancelEdit()"
                    [disabled]="isSaving">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.cancel' | translate }}
            </button>
            <button mat-flat-button
                    type="button"
                    class="btn-tone-primary"
                    (click)="save()"
                    [disabled]="isSaving || !canSave">
              <mat-icon>save</mat-icon>
              {{ isCreateMode ? ('dailySchedulesCatalog.actions.createSchedule' | translate) : ('common.saveChanges' | translate) }}
            </button>
            }
          </div>
        </div>

        <div class="daily-schedule-panel__body">
          @if (isCreateMode || isEditMode) {
          <div class="daily-schedule-editor">
            <div class="daily-schedule-editor__layout">
              <div class="daily-schedule-editor__main">

            <div class="card daily-schedule-editor__section mb-0">
              <div class="card-body">
                <div class="daily-schedule-section-heading">
                  <div class="daily-schedule-section-heading__icon">
                    <mat-icon>domain</mat-icon>
                  </div>
                  <div class="daily-schedule-section-heading__copy">
                    <div class="daily-schedule-section-heading__title">
                      <h4>{{ 'dailySchedulesCatalog.sections.general' | translate }}</h4>
                      <span class="daily-schedule-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                    </div>
                    <p>{{ 'dailySchedulesCatalog.sections.generalDescription' | translate }}</p>
                  </div>
                </div>

                <div class="row g-3">
                  @if (hasMultipleCompanies) {
                  <div class="col-12 col-lg-12 col-xl-12">
                    <app-company-select [records]="companies" [value]="form.companiesRecordId"
                                        [label]="'orgUnitsCatalog.fields.company' | translate"
                                        [placeholder]="'orgUnitsCatalog.fields.company' | translate"
                                        [disabled]="isSaving"
                                        (valueChange)="form.companiesRecordId = $event; selectedCompanyId = $event; onCompanyChange()" />
                  </div>
                  }
                  <div class="col-12 col-lg-6 col-xl-6">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'dailySchedulesCatalog.fields.name' | translate }}</mat-label>
                      <input matInput
                             [(ngModel)]="form.name"
                             [disabled]="isSaving"
                             [placeholder]="'dailySchedulesCatalog.fields.namePlaceholder' | translate">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-lg-6 col-xl-6">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'dailySchedulesCatalog.fields.mode' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.mode"
                                  [disabled]="isSaving"
                                  (ngModelChange)="onModeChange()">
                        @for (modeOption of scheduleModes; track modeOption) {
                        <mat-option [value]="modeOption">{{ getModeLabel(modeOption) }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-lg-12 col-xl-12">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'dailySchedulesCatalog.fields.journey' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.journeyId"
                                  (ngModelChange)="onJourneyChange($event)"
                                  [disabled]="isSaving || !journeys.length">
                        @for (journey of journeys; track journey.journeyId) {
                        <mat-option [value]="journey.journeyId">{{ journey.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="card daily-schedule-editor__section mb-0">
              <div class="card-body">
                <div class="daily-schedule-section-heading">
                  <div class="daily-schedule-section-heading__icon">
                    <mat-icon>schedule</mat-icon>
                  </div>
                  <div class="daily-schedule-section-heading__copy">
                    <div class="daily-schedule-section-heading__title">
                      <h4>{{ 'dailySchedulesCatalog.sections.modeConfiguration' | translate }}</h4>
                      <span class="daily-schedule-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                    </div>
                    <p>{{ 'dailySchedulesCatalog.sections.modeConfigurationDescription' | translate }}</p>
                  </div>
                </div>

                <div class="row g-3">
                  @if (usesFixedTimeRange) {
                  <div class="col-12"
                       [class.col-md-6]="form.mode === 'fixed_full' || usesEntryWindow || usesWorkMinuteLimits"
                       [class.col-xl-6]="form.mode === 'fixed_full'"
                       [class.col-xl-4]="usesEntryWindow || usesWorkMinuteLimits">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'dailySchedulesCatalog.fields.startTime' | translate }}</mat-label>
                      <input matInput
                             #startTimeInput
                             type="time"
                             [(ngModel)]="form.startTime"
                             [disabled]="isSaving"
                             (click)="!isSaving && openTimePicker(startTimeInput)">
                      <button mat-icon-button
                              matSuffix
                              type="button"
                              tabindex="-1"
                              [disabled]="isSaving"
                              (click)="openTimePicker(startTimeInput)">
                        <mat-icon>schedule</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  }
                  @if (form.mode === 'fixed_full') {
                  <div class="col-12 col-md-6 col-xl-6">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'dailySchedulesCatalog.fields.endTime' | translate }}</mat-label>
                      <input matInput
                             #endTimeInput
                             type="time"
                             [(ngModel)]="form.endTime"
                             [disabled]="isSaving"
                             (click)="!isSaving && openTimePicker(endTimeInput)">
                      <button mat-icon-button
                              matSuffix
                              type="button"
                              tabindex="-1"
                              [disabled]="isSaving"
                              (click)="openTimePicker(endTimeInput)">
                        <mat-icon>schedule</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  }
                  @if (usesEntryWindow) {
                  <div class="col-12 col-md-6 col-xl-4">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'dailySchedulesCatalog.fields.entryWindowStartTime' | translate }}</mat-label>
                      <input matInput
                             #entryWindowStartInput
                             type="time"
                             [(ngModel)]="form.entryWindowStartTime"
                             [disabled]="isSaving"
                             (click)="!isSaving && openTimePicker(entryWindowStartInput)">
                      <button mat-icon-button
                              matSuffix
                              type="button"
                              tabindex="-1"
                              [disabled]="isSaving"
                              (click)="openTimePicker(entryWindowStartInput)">
                        <mat-icon>schedule</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-md-6 col-xl-4">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'dailySchedulesCatalog.fields.entryWindowEndTime' | translate }}</mat-label>
                      <input matInput
                             #entryWindowEndInput
                             type="time"
                             [(ngModel)]="form.entryWindowEndTime"
                             [disabled]="isSaving"
                             (click)="!isSaving && openTimePicker(entryWindowEndInput)">
                      <button mat-icon-button
                              matSuffix
                              type="button"
                              tabindex="-1"
                              [disabled]="isSaving"
                              (click)="openTimePicker(entryWindowEndInput)">
                        <mat-icon>schedule</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  }
                  @if (usesWorkMinuteLimits) {
                  <div class="col-12 col-md-6 col-xl-4">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'dailySchedulesCatalog.fields.minimumWorkMinutes' | translate }}</mat-label>
                      <input matInput
                             type="number"
                             min="1"
                             step="1"
                             [(ngModel)]="form.minimumWorkMinutes"
                             [disabled]="isSaving">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-md-6 col-xl-4">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'dailySchedulesCatalog.fields.maximumWorkMinutes' | translate }}</mat-label>
                      <input matInput
                             type="number"
                             min="1"
                             step="1"
                             [(ngModel)]="form.maximumWorkMinutes"
                             [disabled]="isSaving">
                    </mat-form-field>
                  </div>
                  }
                  @if (isSplitShiftMode) {
                  <div class="col-12">
                    <div class="daily-schedule-blocks">
                      <div class="daily-schedule-blocks__header">
                        <strong>{{ 'dailySchedulesCatalog.fields.blocks' | translate }}</strong>
                        <button mat-stroked-button
                                type="button"
                                class="btn-tone-neutral"
                                (click)="addBlock()"
                                [disabled]="isSaving">
                          <mat-icon>add</mat-icon>
                          {{ 'dailySchedulesCatalog.actions.addBlock' | translate }}
                        </button>
                      </div>

                      @for (block of form.blocks; track trackBlock($index); let i = $index) {
                      <div class="row g-2">
                        <div class="col-12 col-lg-5">
                          <mat-form-field subscriptSizing="dynamic" appearance="outline">
                            <mat-label>{{ 'dailySchedulesCatalog.fields.blockStart' | translate }} #{{ i + 1 }}</mat-label>
                            <input matInput
                                   #blockStartInput
                                   type="time"
                                   [(ngModel)]="block.startTime"
                                   [ngModelOptions]="{standalone: true}"
                                   [disabled]="isSaving"
                                   (click)="!isSaving && openTimePicker(blockStartInput)">
                            <button mat-icon-button
                                    matSuffix
                                    type="button"
                                    tabindex="-1"
                                    [disabled]="isSaving"
                                    (click)="openTimePicker(blockStartInput)">
                              <mat-icon>schedule</mat-icon>
                            </button>
                          </mat-form-field>
                        </div>
                        <div class="col-12 col-lg-5">
                          <mat-form-field subscriptSizing="dynamic" appearance="outline">
                            <mat-label>{{ 'dailySchedulesCatalog.fields.blockEnd' | translate }} #{{ i + 1 }}</mat-label>
                            <input matInput
                                   #blockEndInput
                                   type="time"
                                   [(ngModel)]="block.endTime"
                                   [ngModelOptions]="{standalone: true}"
                                   [disabled]="isSaving"
                                   (click)="!isSaving && openTimePicker(blockEndInput)">
                            <button mat-icon-button
                                    matSuffix
                                    type="button"
                                    tabindex="-1"
                                    [disabled]="isSaving"
                                    (click)="openTimePicker(blockEndInput)">
                              <mat-icon>schedule</mat-icon>
                            </button>
                          </mat-form-field>
                        </div>
                        <div class="col-12 col-lg-2 d-flex align-items-center">
                          <button mat-icon-button
                                  type="button"
                                  class="btn-tone-danger"
                                  (click)="removeBlock(i)"
                                  [disabled]="isSaving">
                            <mat-icon>delete_outline</mat-icon>
                          </button>
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                  }
                  <div class="col-12">
                    <div class="daily-schedule-toggle-card daily-schedule-toggle-card--compact">
                      <div class="daily-schedule-toggle-card__icon">
                        <mat-icon>dark_mode</mat-icon>
                      </div>
                      <div>
                        <strong>{{ 'dailySchedulesCatalog.fields.crossesMidnight' | translate }}</strong>
                        <p>{{ 'dailySchedulesCatalog.fields.crossesMidnightHint' | translate }}</p>
                      </div>
                      <mat-slide-toggle [(ngModel)]="form.crossesMidnight"
                                        [disabled]="isSaving || !supportsCrossesMidnight">
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>
              </div>
            </div>

      <div class="meal-config card shadow-sm border-0">
      
        <!-- HEADER -->
        <div class="meal-config__header">
          <div class="meal-config__heading">
            <div class="meal-config__icon"><mat-icon>local_cafe</mat-icon></div>
            <div>
              <h5 class="meal-config__title">{{ 'dailySchedulesCatalog.sections.mealBreak' | translate }}</h5>
              <p class="meal-config__subtitle">
                {{ 'dailySchedulesCatalog.sections.mealBreakDescription' | translate }}
              </p>
            </div>
          </div>
      
          <mat-slide-toggle class="meal-config__main-toggle"
                            [(ngModel)]="form.mealBreak.enabled"
                            [disabled]="isSaving"
                            (ngModelChange)="onMealBreakToggle()">
          </mat-slide-toggle>
        </div>
      
        <!-- CONTENT -->
        @if (mealBreakEnabled) {
        <div class="meal-config__body">
      
          <!-- BLOQUE: OPCIONES -->
          <div class="meal-config__row">
      
            <div class="meal-card">
              <div class="meal-card__info">
                <span class="meal-card__title">{{ 'dailySchedulesCatalog.fields.mealBreakRequired' | translate }}</span>
                <span class="meal-card__desc">{{ 'dailySchedulesCatalog.fields.mealBreakRequiredHint' | translate }}</span>
              </div>
      
              <mat-slide-toggle [(ngModel)]="form.mealBreak.required"
                                [disabled]="isSaving">
              </mat-slide-toggle>
            </div>
      
            <div class="meal-field">
              <mat-form-field subscriptSizing="dynamic" appearance="outline"
                              class="w-100">
                <mat-label>{{ 'dailySchedulesCatalog.fields.mealBreakMode' | translate }}</mat-label>
                <mat-select [(ngModel)]="form.mealBreak.mode"
                            (ngModelChange)="onMealBreakModeChange()"
                            [disabled]="isSaving">
                  @for (modeOption of mealBreakModes; track modeOption) {
                  <mat-option [value]="modeOption">
                    {{ getMealBreakModeLabel(modeOption) }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
      
          </div>
      
          <!-- BLOQUE: INPUTS -->
          <div class="meal-config__row">
      
            <div class="meal-field">
              <mat-form-field subscriptSizing="dynamic" appearance="outline"
                              class="w-100">
                <mat-label>{{ 'dailySchedulesCatalog.fields.mealBreakMinutes' | translate }}</mat-label>
                <input matInput
                       type="number"
                       min="1"
                       [(ngModel)]="form.mealBreak.minutes">
              </mat-form-field>
            </div>
      
            @if (fixedMealBreakMode) {
            <div class="meal-field">
              <mat-form-field subscriptSizing="dynamic" appearance="outline"
                              class="w-100">
                <mat-label>{{ 'dailySchedulesCatalog.fields.mealBreakStartTime' | translate }}</mat-label>
                <input matInput
                       #mealBreakStartInput
                       type="time"
                       [(ngModel)]="form.mealBreak.startTime"
                       (click)="openTimePicker(mealBreakStartInput)">
                <button mat-icon-button
                        matSuffix
                        type="button"
                        tabindex="-1"
                        (click)="openTimePicker(mealBreakStartInput)">
                  <mat-icon>schedule</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="meal-field">
              <mat-form-field subscriptSizing="dynamic" appearance="outline"
                              class="w-100">
                <mat-label>{{ 'dailySchedulesCatalog.fields.mealBreakEndTime' | translate }}</mat-label>
                <input matInput
                       #mealBreakEndInput
                       type="time"
                       [(ngModel)]="form.mealBreak.endTime"
                       (click)="openTimePicker(mealBreakEndInput)">
                <button mat-icon-button
                        matSuffix
                        type="button"
                        tabindex="-1"
                        (click)="openTimePicker(mealBreakEndInput)">
                  <mat-icon>schedule</mat-icon>
                </button>
              </mat-form-field>
            </div>
            }
      
            @if (flexibleMealBreakMode) {
            <div class="meal-field">
              <mat-form-field subscriptSizing="dynamic" appearance="outline"
                              class="w-100">
                <mat-label>{{ 'dailySchedulesCatalog.fields.flexibleWindowStartTime' | translate }}</mat-label>
                <input matInput
                       #mealWindowStartInput
                       type="time"
                       [(ngModel)]="form.mealBreak.flexibleWindowStartTime"
                       (click)="openTimePicker(mealWindowStartInput)">
                <button mat-icon-button
                        matSuffix
                        type="button"
                        tabindex="-1"
                        (click)="openTimePicker(mealWindowStartInput)">
                  <mat-icon>schedule</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="meal-field">
              <mat-form-field subscriptSizing="dynamic" appearance="outline"
                              class="w-100">
                <mat-label>{{ 'dailySchedulesCatalog.fields.flexibleWindowEndTime' | translate }}</mat-label>
                <input matInput
                       #mealWindowEndInput
                       type="time"
                       [(ngModel)]="form.mealBreak.flexibleWindowEndTime"
                       (click)="openTimePicker(mealWindowEndInput)">
                <button mat-icon-button
                        matSuffix
                        type="button"
                        tabindex="-1"
                        (click)="openTimePicker(mealWindowEndInput)">
                  <mat-icon>schedule</mat-icon>
                </button>
              </mat-form-field>
            </div>
            }
      
          </div>
      
        </div>
        }
      </div>

              </div>

              <aside class="daily-schedule-editor__preview">
                <div class="daily-schedule-preview__heading">
                  <div class="daily-schedule-preview__icon">
                    <mat-icon>description</mat-icon>
                  </div>
                  <div>
                    <h4>{{ 'dailySchedulesCatalog.preview.title' | translate }}</h4>
                    <p>{{ 'dailySchedulesCatalog.preview.description' | translate }}</p>
                  </div>
                </div>

                <div class="daily-schedule-preview__details">
                  <div class="daily-schedule-preview__row">
                    <mat-icon>business</mat-icon>
                    <span>{{ 'orgUnitsCatalog.fields.company' | translate }}</span>
                    <strong>{{ formCompanyName }}</strong>
                  </div>
                  <div class="daily-schedule-preview__row">
                    <mat-icon>description</mat-icon>
                    <span>{{ 'dailySchedulesCatalog.fields.name' | translate }}</span>
                    <strong>{{ form.name || '—' }}</strong>
                  </div>
                  <div class="daily-schedule-preview__row">
                    <mat-icon>schedule</mat-icon>
                    <span>{{ 'dailySchedulesCatalog.fields.mode' | translate }}</span>
                    <strong>{{ getModeLabel(form.mode) }}</strong>
                  </div>
                  <div class="daily-schedule-preview__row">
                    <mat-icon>business_center</mat-icon>
                    <span>{{ 'dailySchedulesCatalog.fields.journey' | translate }}</span>
                    <strong>{{ getJourneyName(form.journeyId) }}</strong>
                  </div>

                  <div class="daily-schedule-preview__times">
                    <div class="daily-schedule-preview__time daily-schedule-preview__time--entry">
                      <mat-icon>arrow_forward</mat-icon>
                      <span>{{ 'dailySchedulesCatalog.preview.entry' | translate }}</span>
                      <strong>{{ formStartTimeLabel }}</strong>
                    </div>
                    <div class="daily-schedule-preview__time daily-schedule-preview__time--exit">
                      <mat-icon>arrow_back</mat-icon>
                      <span>{{ 'dailySchedulesCatalog.preview.exit' | translate }}</span>
                      <strong>{{ formEndTimeLabel }}</strong>
                    </div>
                  </div>

                  <div class="daily-schedule-preview__row">
                    <mat-icon>dark_mode</mat-icon>
                    <span>{{ 'dailySchedulesCatalog.fields.crossesMidnight' | translate }}</span>
                    <strong>{{ (form.crossesMidnight ? 'common.yes' : 'common.no') | translate }}</strong>
                  </div>
                  <div class="daily-schedule-preview__row">
                    <mat-icon>local_cafe</mat-icon>
                    <span>{{ 'dailySchedulesCatalog.fields.mealBreak' | translate }}</span>
                    <strong>{{ getMealBreakSummary(form) }}</strong>
                  </div>
                </div>

                <div class="daily-schedule-preview__status"
                     [class.daily-schedule-preview__status--valid]="canSave">
                  <mat-icon>{{ canSave ? 'check_circle' : 'info' }}</mat-icon>
                  <div>
                    <strong>{{ (canSave ? 'dailySchedulesCatalog.preview.ready' : 'dailySchedulesCatalog.preview.incomplete') | translate }}</strong>
                    <span>{{ (canSave ? 'dailySchedulesCatalog.preview.readyHint' : 'dailySchedulesCatalog.preview.incompleteHint') | translate }}</span>
                  </div>
                </div>
              </aside>
            </div>
          </div>
          } @else if (selectedSchedule; as schedule) {
          <div class="daily-schedule-detail daily-schedule-detail--redesigned">
            <section class="daily-schedule-overview">
              <div class="daily-schedule-overview-item daily-schedule-overview-item--main"><div class="daily-schedule-round-icon"><mat-icon>schedule</mat-icon></div><div><span>Horario</span><strong>{{ scheduleStartLabel }} – {{ scheduleEndLabel }}</strong><small>Entrada – Salida</small></div></div>
              <div class="daily-schedule-overview-item"><div class="daily-schedule-round-icon"><mat-icon>open_in_full</mat-icon></div><div><span>Permanencia total</span><strong>{{ formatDuration(scheduleTotalMinutes) }}</strong><small>Tiempo en la empresa</small></div></div>
              <div class="daily-schedule-overview-item"><div class="daily-schedule-round-icon"><mat-icon>local_cafe</mat-icon></div><div><span>{{ 'dailySchedulesCatalog.fields.mealBreak' | translate }}</span><strong>{{ getMealBreakSummary(schedule) }}</strong><small>{{ schedule.mealBreak.enabled ? 'Tiempo de comida configurado' : 'No se descuenta tiempo de comida' }}</small></div></div>
              <div class="daily-schedule-overview-item daily-schedule-overview-item--type"><div class="daily-schedule-round-icon"><mat-icon>{{ associatedJourneyTypeIcon }}</mat-icon></div><div><span>Tipo de jornada</span><strong>{{ associatedJourneyTypeLabel }}</strong><small>Jornada asociada</small></div></div>
            </section>

            <section class="daily-schedule-visual-card">
              <div class="daily-schedule-card-heading"><mat-icon>calendar_month</mat-icon><div><h4>Visualización del horario</h4><p>Representación gráfica del horario durante el día.</p></div></div>
              <div class="daily-schedule-timeline">
                <div class="daily-schedule-timeline__limits"><strong>{{ scheduleStartLabel }}</strong><strong>{{ scheduleEndLabel }}</strong></div>
                <div class="daily-schedule-timeline__bar">
                  <span class="daily-schedule-timeline__work" [style.width.%]="schedule.mealBreak.enabled ? mealTimelineStartPercent : 100"></span>
                  @if (schedule.mealBreak.enabled) {
                  <span class="daily-schedule-timeline__meal" [style.width.%]="mealTimelineWidthPercent"></span>
                  <span class="daily-schedule-timeline__work" [style.width.%]="mealTimelineEndPercent"></span>
                  }
                </div>
                <div class="daily-schedule-timeline__captions"><span>Entrada</span><div>Permanencia total<strong>{{ formatDuration(scheduleTotalMinutes) }}</strong></div><span>Salida</span></div>
              </div>
            </section>

            <div class="daily-schedule-info-grid">
              <section class="daily-schedule-info-card">
                <div class="daily-schedule-card-heading"><mat-icon>settings</mat-icon><div><h4>Configuración del horario</h4><p>Parámetros generales del horario diario.</p></div></div>
                <div class="daily-schedule-detail-list">
                  <div><mat-icon>event_available</mat-icon><span>{{ 'dailySchedulesCatalog.fields.mode' | translate }}</span><strong>{{ getModeLabel(schedule.mode) }}<small>Configuración del horario</small></strong></div>
                  <div><mat-icon>local_cafe</mat-icon><span>{{ 'dailySchedulesCatalog.fields.mealBreak' | translate }}</span><strong>{{ getMealBreakSummary(schedule) }}<small>{{ schedule.mealBreak.enabled ? getMealBreakModeLabel(schedule.mealBreak.mode) : 'No se descuenta tiempo de comida' }}</small></strong></div>
                  <div><mat-icon>business_center</mat-icon><span>{{ 'dailySchedulesCatalog.fields.journey' | translate }}</span><strong>{{ getJourneyName(schedule.journeyId) }}<small>{{ associatedJourneyTypeLabel }} · {{ formatDuration(scheduleEffectiveMinutes) }} efectivas</small></strong></div>
                </div>
              </section>

              <section class="daily-schedule-info-card">
                <div class="daily-schedule-card-heading"><mat-icon>business_center</mat-icon><div><h4>Jornada asociada</h4><p>Jornada que se utiliza en este horario diario.</p></div></div>
                <div class="daily-schedule-journey-card">
                  <div class="daily-schedule-journey-card__header"><div class="daily-schedule-round-icon"><mat-icon>schedule</mat-icon></div><div><strong>{{ getJourneyName(schedule.journeyId) }}</strong><span>{{ associatedJourneyTypeLabel }} · {{ formatDuration(scheduleEffectiveMinutes) }} efectivas</span></div><button mat-stroked-button type="button" (click)="viewAssociatedJourney()" [disabled]="!schedule.journeyId">Ver jornada <mat-icon>arrow_forward</mat-icon></button></div>
                  <div class="daily-schedule-journey-card__metrics">
                    <div><mat-icon>schedule</mat-icon><span>Tiempo efectivo<strong>{{ formatDuration(scheduleEffectiveMinutes) }}</strong></span></div>
                    <div><mat-icon>local_cafe</mat-icon><span>Tiempo de comida<strong>{{ formatDuration(scheduleMealMinutes) }}</strong><small>{{ schedule.mealBreak.enabled ? getMealBreakModeLabel(schedule.mealBreak.mode) : 'Sin comida' }}</small></span></div>
                    <div><mat-icon>{{ associatedJourneyTypeIcon }}</mat-icon><span>Tipo de jornada<strong>{{ associatedJourneyTypeLabel }}</strong></span></div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          } @else {
          <div class="daily-schedule-empty">
            <mat-icon>schedule</mat-icon>
            <h4>{{ 'dailySchedulesCatalog.emptyEditorTitle' | translate }}</h4>
            <p>{{ 'dailySchedulesCatalog.emptyEditorDescription' | translate }}</p>
          </div>
          }
        </div>
      </mat-card>

      @if (isLoading) {
      <app-loading-state class="daily-schedule-loading"
                         [message]="'dailySchedulesCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
